<div class="invoice-adjustment">
  <!-- Dialog header -->
  <div class="flex-between-center px-3 py-2 border-bottom-lightest height">
    <div class="flex-column">
      <div class="font-700 text-truncate flex-start-center">
        <span class="uppercase">RO# {{this.payment?.estimate?.code}}</span>
        - {{this.payment?.estimate?.title}}
      </div>

      <div class="font-11 font-600 font-gray-35 rev-customer-email-phone">
        {{ title }}
        <span *ngIf="payment?.customer?.phone"> - ({{ payment?.customer?.phone | mask : '(000) 000-0000' }})</span>
      </div>
    </div>

    <div class="font-16 font-300 font-gray-55 pointer" (click)="closePaymentModal({})">
      <i class="fal fa-times"></i>
    </div>
  </div>

  <div class="invoice-adjustment-body flex-row">
    <div class="invoice-adjustment-left border-right-light p-0 w-70">
      <div class="flex-column info-section px-3 py-2 height">
        <!-- Amount & Date & Time -->
        <div class="flex-row mb-3">
          <div class="ui-g-4 p-0 pr-2">
            <label class="font-12 font-600 mb-4px">Refund Amount*</label>
            <app-input id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
              [hasHoverBorderBottom]="false" [disabled]="true" [hasHoverEffect]="false"
              [value]="abs((payment?.estimate?.total) || 0) | currency: usd">
            </app-input>

            <label id="payment-validation-amount" class="error-label" *ngIf="validate.amount">
              {{ validate.amount }}
            </label>
            <label id="payment-validation-range" class="error-label" *ngIf="validate.range">
              {{ validate.range }}
            </label>
          </div>

          <div class="ui-g-4 p-0 pr-2">
            <label class="font-12 font-600 mb-4px">Date</label>
            <div class="calendar-input flex-between-center payment-date pointer"
              [ngClass]="{ 'disabled-with-default': !changePaymentData && isPaymentDataPrivilgesEnabled}">
              <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer pl-1"
                [(ngModel)]="payment.paymentDate" [readonlyInput]="true" [minDate]="payment?.estimate?.createdAt"
                [maxDate]="maxDateRange" dateFormat="M d, yy"
                [disabled]="!changePaymentData && isPaymentDataPrivilgesEnabled" (onSelect)="onDateTimeChange($event)"
                #paymentDateTimeEl></p-calendar>
              <i class="fal fa-calendar-alt pr-2"
                (click)="(isPaymentDataPrivilgesEnabled && changePaymentData && 
                    paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
            </div>
          </div>

          <div class="ui-g-4 p-0">
            <label class="font-12 font-600 mb-4px">Time*</label>
            <div class="ro-adjustment">
              <kendo-timepicker [(value)]="paymentTime" popupClass="testing" class="w-100"
                [disabled]="!changePaymentData && isPaymentDataPrivilgesEnabled"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
              </kendo-timepicker>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="flex-row">
          <div class="flex-column w-100">
            <label class="font-12 font-600 mb-4px">Notes</label>
            <div class="form-group custom-text-area font-14 mb-2">
              <textarea id="invoice-adjustment-notes" name="notes" [disabled]="false" placeholder="" rows="4"
                (ngModelChange)="onChangenNote($event)" [(ngModel)]="payment.notes"></textarea>
            </div>
          </div>

        </div>

        <!-- description -->
        <div class="width-100p border-bottom-light">
          <div class="flex-column">
            <span class="font-16 font-700">Net Payments and Refunds from Original and Adjustment invoices</span>

            <span class="font-12 font-600 font-gray-45 width-90p mb-2">
              Refund against an original payment* or refund via Cash or Credit Memo or against unpaid Invoices for same
              customer
            </span>
          </div>
        </div>

        <!-- Payment methods -->
        <div *ngIf="loader.isPaymentLoading || paymentHistory?.length" class="flex-row mb-2">
          <div class="flex-cloumn w-100">
            <div class="flex-row mt-2 mb-1">
              <div class="ui-g-8 p-0">
                <span class="font-13 font-700 font-gray-45">
                  Refund via Past Payments Methods
                </span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-600 font-gray-45">Balance</span>
              </div>

              <div class="ui-g-2 p-0 ">
                <span class="font-13 font-600 font-gray-45">Refund Amount</span>
              </div>
            </div>

            <div class="payment-lines-container flex-column">
              <div *ngIf="loader.isPaymentLoading" class="flex-center-center width-100p">
                <i class="fal fa-spinner rotate"></i>
              </div>

              <div *ngFor="let pHistory of paymentHistory; let paymentIndex = index;"
                class="payment-lines flex-center-center mb-2 p-1">
                <div class="ui-g-8 p-0 pl-2">
                  <span *ngIf="pHistory.paymentType === 'cash'">
                    Cash
                  </span>

                  <span *ngIf="pHistory.paymentType === 'cheque'">
                    {{ checkTxt }} {{ pHistory.checkNo }}
                  </span>

                  <span *ngIf="pHistory.paymentType === 'card' && (pHistory.isOnline || pHistory.isCardSwipe)">
                    {{ pHistory?.isOnline ? 'Card ' + pHistory?.cardType : pHistory?.isCardSwipe ? 'Card ' +
                    pHistory?.cardType : 'Card (Manual)' }}
                  </span>

                  <span [hidden]="pHistory.isOnline || pHistory.isCardSwipe" *ngIf="pHistory.paymentType === 'card'">
                    Card {{ pHistory.cardType }} *{{ pHistory.card4Digits}}
                  </span>

                  <span *ngIf="pHistory.paymentType === 'Refund'">
                    {{ pHistory?.title }}
                  </span>

                  <span *ngIf="pHistory.paymentType === 'creditPayment'">
                    {{ pHistory.creditMethodType }}
                  </span>

                  <span>&nbsp;-&nbsp;{{pHistory?.createdAt | date: 'MMM dd, yyyy'}}</span>
                </div>

                <div class="ui-g-2 p-0">
                  <span class="font-13 font-400 font-gray-45">{{(pHistory.amount || 0) | currency : usd}}</span>
                </div>

                <div class="ui-g-2 flex-column p-0">
                  <app-input id="payment-amount-balance-{{paymentIndex}}" placeholder="$0.00" theme="border"
                    [fontSize]="12" [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
                    [allowDecimal]="pHistory?.isRefundAmountFocus ? true : false"
                    [autoFocus]="pHistory.isRefundAmountFocus" [hasHoverEffect]="false"
                    [isInvalid]="pHistory.error || (pHistory.refundAmount > 0 && refundRemaining < 0)"
                    [value]="pHistory.isRefundAmountFocus ? pHistory.refundAmount : (pHistory.refundAmount | currency : usd)"
                    (appChange)="handleChange($event, pHistory, 'refundAmount')" (appFocus)="handleFocus(pHistory)"
                    (appBlur)="handleBlur(pHistory)">
                  </app-input>
                  <span *ngIf="pHistory.refundAmount > 0 && refundRemaining < 0 && pHistory.isRefundAmountFocus"
                    class="font-11 font-alert-500">
                    Amount cannot exceed remainig refund amount
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Refund via Cash -->
        <div class="flex-row mb-2">
          <div class="flex-cloumn w-100">
            <div class="flex-row mt-2 mb-2">
              <div class="ui-g-8 p-0">
                <span class="font-13 font-700 font-gray-45">
                  Refund via Cash
                </span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-600 font-gray-45"></span>
              </div>

              <div class="ui-g-2 p-0 ">
                <span class="font-13 font-600 font-gray-45"> </span>
              </div>
            </div>

            <div class="payment-lines flex-center-center mb-2 p-2">
              <div class="ui-g-8 p-0 pl-2">
                <span class="font-13 font-400 font-gray-45">Cash</span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-400 font-gray-45"></span>
              </div>

              <div class="ui-g-2 flex-column p-0">
                <app-input id="invoice-adj-cash" placeholder="$0.00" theme="border" [fontSize]="13"
                  [selectTextOnFocus]="true" [hasHoverBorderBottom]="false" [hasHoverEffect]="false"
                  [allowDecimal]="cashPaymentRefunds?.isRefundAmountFocus"
                  [autoFocus]="cashPaymentRefunds?.isRefundAmountFocus" [disabled] ="disableRefundAmount"
                  [isInvalid]="cashPaymentRefunds.refundAmount > 0 && refundRemaining < 0"
                  tooltipPosition="top"
                  tooltipStyleClass="motor-vehicle-link-tooltip font-11"
                  [pTooltip]="disableRefundAmount ? 'Entire amount must be refunded using a single method' :''"
                  [value]="cashPaymentRefunds?.isRefundAmountFocus ? cashPaymentRefunds.refundAmount : (cashPaymentRefunds.refundAmount | currency : usd)"
                  (appChange)="handleChange($event, cashPaymentRefunds, 'refundAmount', 'cashPaymentRefunds')"
                  (appFocus)="handleFocus(cashPaymentRefunds)" (appBlur)="handleBlur(cashPaymentRefunds)">
                </app-input>
                <span
                  *ngIf="cashPaymentRefunds.refundAmount > 0 && refundRemaining < 0 && cashPaymentRefunds.isRefundAmountFocus"
                  class="font-11 font-alert-500">
                  Amount cannot exceed remainig refund amount
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Refund via Credit Memos -->
        <div class="flex-row mb-2">
          <div class="flex-cloumn w-100">
            <div class="flex-row">
              <div class="ui-g-8 p-0">
                <span class="font-13 font-700 font-gray-45">
                  Issue Refund via new credit memo or against unpaid open invoices
                </span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-600 font-gray-45"></span>
              </div>

              <div class="ui-g-2 p-0 ">
                <span class="font-13 font-600 font-gray-45"> </span>
              </div>
            </div>

            <div class="payment-lines flex-center-center mb-2 p-2" [ngClass]="error?.creditAmount && 'align-start'">
              <div class="ui-g-8 p-0 pl-2">
                <span class="font-13 font-400 font-gray-45">New Credit Memo</span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-400 font-gray-45"></span>
              </div>

              <div class="ui-g-2 p-0" [ngClass]="error?.creditAmount && 'height-80'">
                <app-input id="invoice-adj-credit-memo" placeholder="$0.00" theme="border" [fontSize]="13"
                  [selectTextOnFocus]="true" [hasHoverBorderBottom]="false" [hasHoverEffect]="false"
                  [allowDecimal]="creditMemoRefunds?.isRefundAmountFocus" [isInvalid]="error.creditAmount"
                  tooltipPosition="top"
                  tooltipStyleClass="motor-vehicle-link-tooltip font-11"
                  [pTooltip]="disableCreditMemoRefunds ? 'Entire amount must be refunded using a single method' :''" 
                  [isInvalid]="creditMemoRefunds.refundAmount > 0 && refundRemaining < 0" [disabled]="disableCreditMemoRefunds"
                  [errorMessage]="error?.creditAmount" [autoFocus]="creditMemoRefunds?.isRefundAmountFocus"
                  [value]="creditMemoRefunds?.isRefundAmountFocus ? creditMemoRefunds.refundAmount : (creditMemoRefunds.refundAmount | currency : usd)"
                  (appChange)="handleChange($event, creditMemoRefunds, 'refundAmount','creditMemoRefunds')"
                  (appFocus)="handleFocus(creditMemoRefunds)" (appBlur)="handleBlur(creditMemoRefunds)">
                </app-input>
                <span
                  *ngIf="creditMemoRefunds.refundAmount > 0 && refundRemaining < 0 && creditMemoRefunds.isRefundAmountFocus"
                  class="font-11 font-alert-500">
                  Amount cannot exceed remainig refund amount
                </span>
              </div>
            </div>

            <div *ngIf="loader.isUnpaidInvoiceLoading" class="flex-center-center width-100p">
              <i class="fal fa-spinner rotate"></i>
            </div>

            <div *ngFor="let invoice of unpaidInvoices; let i = index"
              class="payment-lines flex-center-center mb-2 p-2">
              <div class="ui-g-8 p-0 pl-2">
                <span class="font-13 font-400 font-gray-45">{{invoice.balanceText}}</span>
              </div>

              <div class="ui-g-2 p-0">
                <span class="font-13 font-400 font-gray-45">
                  {{(invoice.total?.unpaid || 0) | currency : usd}}
                </span>
              </div>

              <div class="ui-g-2 p-0">
                <app-input id="invoice-adj-unpaid-inv-{{i}}" placeholder="$0.00" theme="border" [fontSize]="13"
                  [selectTextOnFocus]="true" [hasHoverBorderBottom]="false" [hasHoverEffect]="false"
                  tooltipPosition="top"
                  tooltipStyleClass="motor-vehicle-link-tooltip font-11"
                  [pTooltip]="invoice?.invoiceRefundAmount ? 'Entire amount must be refunded using a single method' :''" 
                  [allowDecimal]="invoice?.isRefundAmountFocus" [autoFocus]="invoice?.isRefundAmountFocus" [value]="invoice?.isRefundAmountFocus?
                  invoice.refundAmount : (invoice.refundAmount | currency : usd)" [disabled]="invoice?.invoiceRefundAmount"
                  [isInvalid]="invoice.error || (invoice.refundAmount > 0 && refundRemaining < 0)"
                  (appChange)="handleChange($event, invoice, 'refundAmount','invoiceRefundAmount')" (appFocus)="handleFocus(invoice)"
                  (appBlur)="handleBlur(invoice)">
                </app-input>
                <span *ngIf="invoice.refundAmount > 0 && refundRemaining < 0 && invoice.isRefundAmountFocus"
                  class="font-11 font-alert-500">
                  Amount cannot exceed remainig refund amount
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="isDotValid !== undefined && validations?.hasUnassignedClassification !== undefined && isDotValid && !validations?.hasUnassignedClassification" class="flex-end-center info-section-footer px-3 py-2">
        <button class="btn btn-primary btn-submit" [disabled]="isFinalized || isProcessing || refundRemaining !== 0"
          (click)="onSubmit()">
          <span>Apply refund and finalize</span>
          <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-2"></i>
        </button>
      </div>
      <div *ngIf="isDotValid !== undefined && validations?.hasUnassignedClassification !== undefined && (!isDotValid || validations?.hasUnassignedClassification)" class="flex-between-center alert alert-primary p-2 m-3">
        <div class="flex-column">
          <div>
            <i class="fal fa-exclamation-triangle mr-1"></i>
            <span>Some information is missing:</span>
          </div>
          <ul class="pl-4">
            <li *ngIf="!isDotValid">
              Missing DOT#
            </li>
            <li *ngIf="validations?.hasUnassignedClassification">
              There are items that require sales code assignment
            </li>
          </ul>
        </div>
        <button class="btn btn-primary" (click)="openTireDotNumberModal()">
          Update details
        </button>
      </div>

    </div>
    <div class="invoice-adjustment-right w-30 px-3 py-2">
      <div class="flex-column">
        <!-- Summary section -->
        <div class="font-13 summary-section flex-cloumn">
          <p class=" font-700 font-gray-45">Summary</p>

          <div class="py-2 font-600 flex-between-center">
            <span>Total refund value</span>
            <span>{{abs(payment?.estimate?.total || 0) | currency: usd}}</span>
          </div>

          <div class="mb-2">
            <div class="font-600 flex-between-center">
              <span>Issue Credit Memo</span>
              <span>{{abs(creditAppliedAmount || 0) | currency: usd}}</span>
            </div>
            <div *ngFor="let history of unpaidInvoices">
              <div class="font-400 pl-2" *ngIf="history.creditRefundValue>0">
                <span>apply to RO# {{history.code}}</span>
                <span class="font-red ml-2">({{abs(history.creditRefundValue || 0) | currency: usd}})</span>
              </div>
            </div>
          </div>

          <div class="border-top-bottom py-2 flex-between-center">
            <span>Refunds to apply</span>
            <span>{{refundApplied | currency: usd}}</span>
          </div>

          <div class="mt-2 py-2 flex-between-center font-700">
            <span>Remaining refund amount</span>
            <span>{{refundRemaining | currency: usd}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>